export default "__VITE_ASSET__CnvpDcSn__"